import { render, staticRenderFns } from "./GORALLocationControls.vue?vue&type=template&id=7479faf4&scoped=true"
import script from "./GORALLocationControls.vue?vue&type=script&lang=js"
export * from "./GORALLocationControls.vue?vue&type=script&lang=js"
import style0 from "./GORALLocationControls.vue?vue&type=style&index=0&id=7479faf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479faf4",
  null
  
)

export default component.exports